import React from "react";
import {NavLink} from 'react-router-dom';

const SideNav = (pr) => {
    return (
        <div id="layoutSidenav_nav">
            <nav className="sidenav shadow-right sidenav-light">
                <div className="sidenav-menu">
                    <div className="nav accordion" id="accordionSidenav">
                        <NavLink to="/dashboard" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-activity"></i></div>
                            Dashboard
                        </NavLink>
                        <NavLink to="/Wishlistdata" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-suit-heart-fill"></i></div>
                            Wishlist
                        </NavLink>
                        <NavLink to="/cart" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-cart-check-fill"></i></div>
                            Cart
                        </NavLink>
                        <NavLink to="/orders" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-cart-check-fill"></i></div>
                            Orders
                        </NavLink>
                        <NavLink to="/artworkAll" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Artwork 
                        </NavLink>
                        <NavLink to="/inventoryAll" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Inventory
                        </NavLink>
                        <NavLink to="/users" className='nav-link'>
                        <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Users
                        </NavLink>
                        <NavLink to="/exhibition" className='nav-link'>
                        <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Exhibitions
                        </NavLink>
                        <NavLink to="/blogAll" className='nav-link'>
                        <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Blogs
                        </NavLink>
                        <NavLink to="/priceRequest" className='nav-link'>
                        <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Price Request
                        </NavLink>
                        <NavLink to="/contactUs" className='nav-link'>
                        <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Contact Us
                        </NavLink>
                        <NavLink to="/videos-panel" className='nav-link'>
                        <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Videos Panel
                        </NavLink>
                        <NavLink to="/policy" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Policy Details
                        </NavLink>
                        <NavLink to="/subject" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Subjects
                        </NavLink>
                        <NavLink to="/styles" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Styles
                        </NavLink>
                        <NavLink to="/surface" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Surface
                        </NavLink>
                        <NavLink to="/medium" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Medium / Material
                        </NavLink>
                        <NavLink to="/currency" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Currency
                        </NavLink>
                        <NavLink to="/shippingCost" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Shipping Cost
                        </NavLink>
                        <NavLink to="/mailerCustom" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            Custom Mailer
                        </NavLink>

                    </div>
                </div>

            </nav >
        </div >
    )
}

export default SideNav;